function Footer() {
  return (
    <div className="footer-container">
      <li>
        <ul>
          <a
            className="footer-links"
            href="https://github.com/SubliminalGuy"
            target="_blank"
            rel="noreferrer"
          >
            github
          </a>
        </ul>
        <ul>
          <a
            className="footer-links"
            href="https://mastodon.sdf.org/@subliminal_guy"
            target="_blank"
            rel="noreferrer"
          >
            mastodon
          </a>
        </ul>
        <ul>
          <a
            className="footer-links"
            href="https://50reactprojects.com"
            target="_blank"
            rel="noreferrer"
          >
            #50 React Projects
          </a>
        </ul>
      </li>
    </div>
  );
}

export default Footer;
